import script from "./SignUpPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUpPage.vue?vue&type=script&setup=true&lang=ts"

import "./SignUpPage.vue?vue&type=style&index=0&id=10aa27d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10aa27d2"]])

export default __exports__